import { HomeHeroImage, HomeHeroRow, HomeHeroText, HomeHeroCTO, Story, Details, ButtonLink } from "../styles";
import { IconLogo } from "../svgs";
import { ASSET_URL } from "../constants";

const Home = () => {
  return (
    <>
      <HomeHeroImage>
        {/*
        <picture className="banner-mobile">
          <source srcset={`${ASSET_URL}/banners/avif/banner-mobile.avif`} type="image/avif" />
          <img src={`${ASSET_URL}/banners/banner-mobile.jpg`} />
        </picture>
        */}
        <picture className="banner-mobile">
          <source srcset={`/images/hero-image.png`} type="image/avif" />
          <img src={`/images/hero-image.png`} />
        </picture>
        <picture className="banner-tablet">
          <source srcset={`/images/hero-image.png`} type="image/avif" />
          <img src={`/images/hero-image.png`} />
        </picture>
        <picture className="banner-desktop">
          <source srcset={`/images/hero-image.png`} type="image/avif" />
          <img src={`/images/hero-image.png`} />
        </picture>
      </HomeHeroImage>
      <HomeHeroRow>
        <HomeHeroText>
          <div className="hero-text-top">
            <span className="upf50-logo">
              <span>UPF</span>50+
            </span>
            <span className="upf50-text">active graphic tees</span>
          </div>
          <span className="hero-text-bottom">for your next outdoor adventure</span>
        </HomeHeroText>
      </HomeHeroRow>
      <Story>
        <IconLogo className="logo" />
        <h2>
          Stay cool, comfortable, and fully protected from harmful UV rays with our UPF50+ Active Graphic Tee. Crafted from a
          moisture-wicking fabric that mimics the soft touch of cotton, this shirt offers ultimate protection without sacrificing comfort.
        </h2>
      </Story>
      <Details>
        <div id="more-info" className="details-content">
          <h3>Designed for the Outdoors</h3>
          <p>
            Whether you're hiking, enjoying outdoor sports, relaxing in the sun or spending the day by the water, the moisture-wicking
            fabric helps you stay cool, dry and protected from harmful rays, while the relaxed fit allows for full range of motion keeping
            you safe and comfortable all day long.
          </p>
          <h3 className="available-size-title">Available in Short Sizes</h3>
          <p>
            Our unisex shirts are made for everyone, with regular and short sizing options so you can find the perfect fit no matter your
            height or body type. Designed to work for all genders, these tees are soft and built for everyday comfort. Choose a classic
            length or a shorter fit for a look that suits your style.
          </p>
        </div>
        <div className="details-graphic">
          <div className="designed-for-outdoors"></div>
          <div className="homepage-size-chart">
            <div>
              <p>SIZES</p>
              <div className="homepage-size-chart-columns">
                <div className="homepage-size-chart-column">
                  <div className="size-heading short">
                    <span className="short">Short</span>
                  </div>
                  <div className="size-values short">
                    <ul>
                      <li>XS</li>
                      <li>S</li>
                      <li>M</li>
                      <li>L</li>
                      <li>XL</li>
                    </ul>
                  </div>
                </div>

                <div className="homepage-size-chart-column">
                  <div className="size-heading reg">
                    <span className="regular">Regular</span>
                  </div>
                  <div className="size-values reg">
                    <ul>
                      <li>SM</li>
                      <li>MD</li>
                      <li>LG</li>
                      <li>XL</li>
                      <li>XXL</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <ButtonLink to="/size-guide" className="autoFitCenter white">
              view size guide
            </ButtonLink>
          </div>
        </div>
      </Details>
    </>
  );
};

export default Home;
